import { defineMessages } from 'react-intl';

export const MIN_ITEMS_LIMIT = 1;
export const MAX_ITEMS_LIMIT = 100;
export const DEFAULT_ITEMS_LIMIT = 5;

const messages = defineMessages({
  listing: {
    id: 'Public consultations listing',
    defaultMessage: 'Public consultations listing',
  },
  itemsLimit: {
    id: 'Items limit',
    defaultMessage: 'Items limit',
  },
  filterByOrganization: {
    id: 'Filter by organization',
    defaultMessage: 'Filter by organization',
  },
  filterByOrganizationDescription: {
    id: 'Filter by organization description',
    defaultMessage:
      "When enabled, only records from this portal's organization are shown.",
  },
});

export const publicConsultationsListingSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.listing),
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.listing),
        fields: ['itemsLimit', 'filterByOrganization'],
      },
    ],
    properties: {
      itemsLimit: {
        title: intl.formatMessage(messages.itemsLimit),
        type: 'number',
        minimum: MIN_ITEMS_LIMIT,
        maximum: MAX_ITEMS_LIMIT,
        default: DEFAULT_ITEMS_LIMIT,
        placeholder: intl.formatMessage(messages.itemsLimit),
      },
      filterByOrganization: {
        title: intl.formatMessage(messages.filterByOrganization),
        type: 'boolean',
        default: true,
        description: intl.formatMessage(
          messages.filterByOrganizationDescription,
        ),
      },
    },
  };
};
